<template>
  <van-popup
    :value="value"
    round
    position="bottom"
    class="invite-detail-popup"
    @input="onInput"
    @click-overlay="close"
  >
    <div class="popup-body" v-if="value">
      <div class="header">
        <span class="title">邀请详情</span>
        <div class="close iconfont icon-cha" @click="close"></div>
      </div>
      <div class="tabs">
        <div
          class="tab"
          :class="{ active: activeTab === 'invited' }"
          @click="activeTab = 'invited'"
        >
          已邀请用户
        </div>
        <div
          class="tab"
          :class="{ active: activeTab === 'activated' }"
          @click="activeTab = 'activated'"
        >
          邀请成功用户
        </div>
      </div>
      <!-- 两个 tab 各自独立滚动容器，滚动位置互不影响 -->
      <div class="list" v-show="activeTab === 'invited'">
        <div class="user-item" v-for="user in invitedList" :key="user.phone">
          <img class="avatar" :src="user.avatar" alt="" />
          <div class="user-info">
            <span class="name">{{ user.nickname }}</span>
            <span class="phone">{{ user.phone }}</span>
          </div>
        </div>
        <div class="empty" v-if="!invitedList.length">暂无数据</div>
        <div class="no-more" v-else>没有更多了</div>
      </div>
      <div class="list" v-show="activeTab === 'activated'">
        <div class="user-item" v-for="user in activatedList" :key="user.phone">
          <img class="avatar" :src="user.avatar" alt="" />
          <div class="user-info">
            <span class="name">{{ user.nickname }}</span>
            <span class="phone">{{ user.phone }}</span>
          </div>
        </div>
        <div class="empty" v-if="!activatedList.length">暂无数据</div>
        <div class="no-more" v-else>没有更多了</div>
      </div>
    </div>
  </van-popup>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    // 已邀请用户列表（页面获取后传入）
    invitedList: {
      type: Array,
      default: () => []
    },
    // 已激活用户列表（页面获取后传入）
    activatedList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      activeTab: 'invited'
    }
  },
  methods: {
    onInput(val) {
      this.$emit('input', val)
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>
<style lang="scss" scoped>
.invite-detail-popup {
  height: 582px;
}
.popup-body {
  height: 100%;
  box-sizing: border-box;
  background: rgba(245, 245, 245, 1);
  border-radius: 16px 16px 0 0;
  padding-top: 12px;
  padding-bottom: constant(safe-area-inset-bottom);
  padding-bottom: env(safe-area-inset-bottom);
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.header {
  position: relative;
  text-align: center;
  .title {
    font-size: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(5, 11, 39, 1);
    line-height: 30px;
  }
  .close {
    position: absolute;
    right: 17px;
    top: 6px;
    padding: 6px;
    font-size: 16px;
    color: #050b27;
  }
}
.tabs {
  display: flex;
  justify-content: space-around;
  padding: 20px 0 0px;
  box-shadow: 0px 1px 0px 0px #ececec;
  .tab {
    position: relative;
    font-size: 15px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: rgba(5, 11, 39, 1);
    line-height: 21px;
    padding-bottom: 12px;
    &.active {
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 16px;
        height: 3px;
        background: rgba(255, 126, 21, 1);
      }
    }
  }
}
.list {
  flex: 1;
  flex-shrink: 0;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
  .user-item {
    display: flex;
    align-items: center;
    width: 335px;
    height: 76px;
    background: #fff;
    border-radius: 8px;
    padding: 12px 16px;
    box-sizing: border-box;
    margin-bottom: 16px;
    .avatar {
      width: 52px;
      height: 52px;
      border-radius: 50%;
      object-fit: cover;
      flex-shrink: 0;
    }
    .user-info {
      display: flex;
      flex-direction: column;
      margin: 7px 0 5px 12px;
      .name {
        font-size: 16px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 16px;
      }
      .phone {
        margin-top: 6px;
        font-size: 12px;
        font-family: MiSans-Normal, MiSans;
        color: #000;
        line-height: 18px;
      }
    }
  }
  .empty,
  .no-more {
    display: block;
    text-align: center;
    font-size: 13px;
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #000;
    line-height: 18px;
    padding: 16px 0 24px;
  }
}
</style>
